import { VodRowViewProps } from '@/types/vod/vodRowType'
import { debounce } from '@/shared/lib'
import { debounceSpeedMedium } from '@/shared/constants/appConstants'
import { RefObject, useCallback, useEffect, useState } from 'react'
import categoryPlaceholder from '@/shared/assets/images/vodCategoryPlaceholder.webp'

export const useAtmospheric = (
    containerRef: RefObject<HTMLDivElement>,
    rows: VodRowViewProps[]
) => {
    const [visibleRowIndex, setVisibleRowIndex] = useState('')
    const [rowElements, setRowElements] = useState<HTMLDivElement[]>([])

    const mainScreen = document.getElementById('MainScreen')

    const calculateVisibilityOfEachRow = () => {
        const viewportHeight = window.innerHeight
        let maxVisibleHeight = 0
        const VISIBILITY_BOOST = 3 // serve to increase height of small height rows
        let mostVisibleRowUrl: VodRowViewProps | undefined
        rowElements.forEach((row) => {
            if (!row) return
            const rect = row.getBoundingClientRect()
            let visibleHeight = 0

            if (rect.top >= 0 && rect.bottom <= viewportHeight) {
                // Fully visible
                visibleHeight = rect.height
            } else if (rect.top < 0 && rect.bottom > 0) {
                // Partly visible at the top
                visibleHeight = rect.bottom
            } else if (
                rect.top < viewportHeight &&
                rect.bottom > viewportHeight
            ) {
                // Partly visible at the bottom
                visibleHeight = viewportHeight - rect.top
            }

            if (visibleHeight * VISIBILITY_BOOST > maxVisibleHeight) {
                maxVisibleHeight = visibleHeight
                const { index } = row.dataset
                if (index) {
                    setVisibleRowIndex(index.toString())
                }
            }
        })

        return mostVisibleRowUrl?.atmosphericUrl || ''
    }

    const handleScroll = debounce(
        calculateVisibilityOfEachRow,
        debounceSpeedMedium
    )

    const handleRefsUpdate = useCallback((refs: HTMLDivElement[]) => {
        setRowElements(refs)
    }, [])

    useEffect(() => {
        const visibleRow = rows.find(
            (item) => item.productId.toString() === visibleRowIndex
        )

        if (visibleRow && mainScreen && containerRef.current) {
            mainScreen.style.backgroundImage = `url(${
                visibleRow?.atmosphericUrl || categoryPlaceholder
            })`
        }
    }, [visibleRowIndex, containerRef.current, rows.length])

    useEffect(() => {
        if (rows[0]) {
            const { atmosphericUrl } = rows[0]
            if (atmosphericUrl && mainScreen) {
                mainScreen.style.backgroundImage = `url(${
                    atmosphericUrl || categoryPlaceholder
                })`
            }

            return () => {
                if (mainScreen) {
                    mainScreen.style.backgroundImage = ''
                }
            }
        }
    }, [rows.length])

    return { rowElements, handleScroll, handleRefsUpdate }
}
